import { useMutation, useQuery } from "@tanstack/react-query";
import { sponsorApiService } from "modules/Library/Sponsor/api/sponsormodule.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

export const useSponserService = (
  searchText?: string | null,
  pageNumber: number = 1,
  pageSize: number = 10,
) => {
  const SelectAllQuery = useQuery({
    queryKey: ["sponser-selectAll", searchText, pageNumber, pageSize],
    queryFn: () =>
      sponsorApiService.getSelectAllData(searchText, pageNumber, pageSize),
    enabled: !!pageNumber && !!pageSize,
  });

  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => sponsorApiService.insertData(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => sponsorApiService.updateData(payload),
  });

  const DeleteMutation = useMutation<
    ApiResponse,
    Error,
    { sponsorid: number; updatereason: string }
  >({
    mutationFn: (payload) =>
      sponsorApiService.deleteData({
        sponsorid: payload.sponsorid,
        updatereason: payload.updatereason,
      }),
  });

  return {
    SelectAllQuery,
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
  };
};
